import {
  useState
} from "react";

import {
  motion
} from "framer-motion";

import Reveal
  from "../components/Reveal";

function CustomOrderPage() {

  const [form, setForm] =
    useState({
      name: "",
      email: "",
      phone: "",
      artworkType: "",
      deity: "",
      size: "",
      message: ""
    });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = (e) => {

    e.preventDefault();

    alert(
      "Custom order request submitted ✨"
    );

  };

  return (

    <div className="
      min-h-screen
      bg-[#FDFCFB]
      pt-36
      pb-24
      px-6
    ">

      <div className="
        max-w-7xl
        mx-auto
        grid
        lg:grid-cols-2
        gap-20
        items-center
      ">

        {/* LEFT */}

        <Reveal>

          <div>

            <p className="
              text-[11px]
              uppercase
              tracking-[0.4em]
              text-stone-400
              mb-6
            ">

              Custom Sacred Art

            </p>

            <h1 className="
              text-5xl
              md:text-7xl
              font-serif
              italic
              leading-[1.05]
              text-stone-900
              mb-10
            ">

              Commission a deeply personal sacred artwork.

            </h1>

            <div className="
              space-y-7
              text-stone-600
              text-lg
              leading-relaxed
            ">

              <p>
                Work directly with Isabi Studio to create handcrafted spiritual art tailored to your space, story and devotion.
              </p>

              <p>
                From deity portraits and glass art to custom paintings and spiritual concepts, every commissioned artwork is crafted with intention and soul.
              </p>

            </div>

            <div className="
              mt-12
              rounded-[2rem]
              overflow-hidden
              shadow-[0_20px_80px_rgba(0,0,0,0.1)]
            ">

              <img
                src="/images/offer-custom.jpg"
                alt="Custom Sacred Art"
                className="
                  w-full
                  h-[500px]
                  object-cover
                "
              />

            </div>

          </div>

        </Reveal>

        {/* RIGHT */}

        <Reveal delay={0.1}>

          <motion.form

            onSubmit={handleSubmit}

            className="
              bg-white/70
              backdrop-blur-2xl
              border border-white/50
              rounded-[2.5rem]
              p-10 md:p-14
              shadow-[0_20px_80px_rgba(0,0,0,0.08)]
            "
          >

            <h2 className="
              text-4xl
              font-serif
              italic
              text-stone-900
              mb-10
            ">

              Request Your Artwork

            </h2>

            <div className="space-y-6">

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none"
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none"
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none"
              />

              <select
                name="artworkType"
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none"
              >

                <option>
                  Select Artwork Type
                </option>

                <option>
                  Spiritual Wall Art
                </option>

                <option>
                  Glass Artwork
                </option>

                <option>
                  Handcrafted Painting
                </option>

                <option>
                  Custom Deity Portrait
                </option>

              </select>

              <input
                type="text"
                name="deity"
                placeholder="Preferred Deity / Theme"
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none"
              />

              <input
                type="text"
                name="size"
                placeholder="Preferred Artwork Size"
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none"
              />

              <textarea
                rows="5"
                name="message"
                placeholder="Describe your vision, preferred colors, references or spiritual concept..."
                onChange={handleChange}
                className="w-full border border-stone-200 px-5 py-4 rounded-2xl bg-white/70 outline-none resize-none"
              />

              <button
                type="submit"
                className="
                  w-full
                  py-5
                  rounded-full
                  bg-black
                  text-white
                  uppercase
                  tracking-[0.3em]
                  text-sm
                  hover:bg-[#C9935A]
                  transition-all duration-500
                "
              >

                Submit Request

              </button>

            </div>

          </motion.form>

        </Reveal>

      </div>

    </div>

  );

}

export default CustomOrderPage;